/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import Header from "../header"
import Footer from "../footer"
import { useLocation } from "@reach/router"

const Layout = ({ children, headerClass, clonedata, lookdata, alternativedata, migrate, yelowtaxi, yelowexpress, showmarquess }) => {
  useEffect(() => {
    // Function to dynamically load a script
    const loadScript = (src, id, attributes) => {
      if (!document.getElementById(id)) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.async = true;
        script.defer = true;
        script.src = src;
        script.id = id;
        // Set additional attributes if provided
        if (attributes) {
          Object.keys(attributes).forEach((key) => {
            script.setAttribute(key, attributes[key]);
          });
        }
        // Append the script to the head of the document
        document.body.appendChild(script);
      }
    };
    // Load the chat script
    const loadScriptsAfterDelay = () => {
      // Load the chat script
      loadScript("//js-na1.hs-scripts.com/22227773.js", "hs-script-loader", {
        key: "chat-script",
      });
      // Add additional scripts as needed
      loadScript(
        "https://js.hs-analytics.net/analytics/1703571900000/22227773.js",
        "hs-analytics"
      );
      loadScript(
        "https://js.usemessages.com/conversations-embed.js",
        "hubspot-messages-loader",
        {
          "data-loader": "hs-scriptloader",
          "data-hsjs-portal": "22227773",
          "data-hsjs-env": "prod",
          "data-hsjs-hublet": "na1",
        }
      );
      loadScript(
        "https://js.hs-banner.com/v2/22227773/banner.js",
        "cookieBanner-22227773",
        {
          "data-cookieconsent": "ignore",
          "data-hs-ignore": "true",
          "data-loader": "hs-scriptloader",
          "data-hsjs-portal": "22227773",
          "data-hsjs-env": "prod",
          "data-hsjs-hublet": "na1",
        }
      );
      loadScript(
        "https://js.hscollectedforms.net/collectedforms.js",
        "CollectedForms-22227773",
        {
          crossorigin: "anonymous",
          "data-leadin-portal-id": "22227773",
          "data-leadin-env": "prod",
          "data-loader": "hs-scriptloader",
          "data-hsjs-portal": "22227773",
          "data-hsjs-env": "prod",
          "data-hsjs-hublet": "na1",
        }
      );

    };
    // Set a timeout to delay loading the scripts
    const timeoutId = setTimeout(loadScriptsAfterDelay, 10000); // Adjust the delay duration as needed (e.g., 2000 milliseconds or 2 seconds)
    // Cleanup the timeout when the component unmounts
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);


  const location = useLocation();
  const pathnameRef = useRef(location.pathname);

  useEffect(() => {
    sessionStorage.setItem('previous_url', pathnameRef.current)
  }, [])

  return (
    <>
      {/* <SSRProvider> */}
      <div className="wrapper">
        <header className={`transparent-header0 ${headerClass}`}>
          <Header yelowtaxi={yelowtaxi} yelowexpress={yelowexpress} showmarquess={showmarquess} />
        </header>
        <main className="main-container">
          {children}
        </main>
        <div className="icon-fix-footer">
                    <a  href="https://wa.me/12108794269" aria-label="telephone"rel="noreferrer" target="_blank">
            <i className="icon zmdi zmdi-whatsapp"></i>
                      </a>
        </div>

        <Footer clonedata={clonedata} lookdata={lookdata} alternativedata={alternativedata} migrate={migrate} />
      </div>
      {/* </SSRProvider> */}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  headerClass: PropTypes.string
}

Layout.defaultProps = {
  headerClass: '',
}

export default Layout
